import { render } from "./Inputpercentage.vue?vue&type=template&id=855379c2&scoped=true"
import script from "./Inputpercentage.vue?vue&type=script&lang=js"
export * from "./Inputpercentage.vue?vue&type=script&lang=js"

import "./Inputpercentage.vue?vue&type=style&index=0&id=855379c2&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855379c2"]])

export default __exports__